export type TeamColours = { background: string; text: string };

const DEFAULT_TEAM_COLOURS: TeamColours = {
  background: '#14171c',
  text: '#ffffff'
};

/**
 * One brand colour per club for the ring around a headshot, with a text colour
 * that reads on it. Clubs whose first colour is white (Fulham, Leeds) use their
 * trim colour so the ring stays visible on a white circle.
 */
const TEAM_COLOURS: Record<string, TeamColours> = {
  ARS: { background: '#ef0107', text: '#ffffff' },
  AVL: { background: '#670e36', text: '#ffffff' },
  BHA: { background: '#0057b8', text: '#ffffff' },
  BOU: { background: '#da291c', text: '#ffffff' },
  BRE: { background: '#e30613', text: '#ffffff' },
  CHE: { background: '#034694', text: '#ffffff' },
  COV: { background: '#78d0f5', text: '#0b2a4a' },
  CRY: { background: '#1b458f', text: '#ffffff' },
  EVE: { background: '#003399', text: '#ffffff' },
  FUL: { background: '#1a1a1a', text: '#ffffff' },
  HUL: { background: '#f5a12d', text: '#1a1a1a' },
  IPS: { background: '#0044a9', text: '#ffffff' },
  LEE: { background: '#ffcd00', text: '#1a1a1a' },
  LIV: { background: '#c8102e', text: '#ffffff' },
  MCI: { background: '#6cabdd', text: '#0b2a4a' },
  MUN: { background: '#da291c', text: '#ffffff' },
  NEW: { background: '#241f20', text: '#ffffff' },
  NFO: { background: '#dd0000', text: '#ffffff' },
  SUN: { background: '#eb172b', text: '#ffffff' },
  TOT: { background: '#132257', text: '#ffffff' },
  WHU: { background: '#7a263a', text: '#ffffff' },
  WOL: { background: '#fdb913', text: '#1a1a1a' }
};

export const teamColoursFor = (teamShortName: string): TeamColours =>
  TEAM_COLOURS[teamShortName] ?? DEFAULT_TEAM_COLOURS;
